export default {
  title: 'Gebühren',
  subtitle: 'Servicegebühr-Überschreibung pro Restaurant für {{company}}.',
  card_title: 'Servicegebühr',
  banner: {
    default_summary: 'Partner-Standard: {{percentage}}% · min {{min}} · max {{max}}.',
    override_hint: 'Überschreiben Sie unten, um eine abweichende Gebühr für dieses Restaurant festzulegen.',
    suggested_summary: 'Empfohlene Startwerte: {{percentage}}% · min {{min}} · max {{max}}.',
    suggested_hint: 'Passen Sie sie unten an und speichern Sie, um in diesem Restaurant eine Servicegebühr zu erheben.',
    own_fee_hint: 'Dieses Restaurant erhebt eine eigene Gebühr, die unten festgelegt ist.',
    saved_summary: 'Ihre zuletzt gespeicherten Werte: {{percentage}}% · min {{min}} · max {{max}}.',
    saved_hint:
      'Die Servicegebühr ist ausgeschaltet. Speichern Sie diese Werte (oder ändern Sie sie vorher), um sie wieder zu aktivieren.',
  },
  form: {
    recommended: 'Empfohlen: {{value}}',
    percentage: {
      label: 'Servicegebühr-Prozentsatz',
      tooltip: 'Prozentsatz des Bestellwerts, der dem Kunden als Servicegebühr berechnet wird.',
    },
    min_amount: {
      label: 'Minimaler Servicegebühr-Betrag',
      tooltip: 'Niedrigere berechnete Gebühren werden auf diesen Betrag aufgerundet.',
    },
    max_amount: {
      label: 'Maximaler Servicegebühr-Betrag',
      tooltip: 'Die Servicegebühr überschreitet diesen Betrag nie, unabhängig vom Bestellwert.',
    },
  },
  limits:
    'Muss innerhalb der FoodAmigos-Limits bleiben: max {{max_percentage}}% / {{max_amount}}, Minimum mindestens {{min_amount}}.',
  not_charged_notice:
    'In diesem Restaurant wird derzeit keine Servicegebühr erhoben. Speichern Sie unten eine Gebühr, um sie zu aktivieren.',
  zero_percentage_warning:
    'Ein Prozentsatz von 0% deaktiviert die Servicegebühr nicht: Berechnete Gebühren unterhalb des Mindestbetrags werden auf diesen aufgerundet, sodass jede Bestellung weiterhin mindestens den Mindestbetrag kostet.',
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
    reset_to_default: 'Auf Partner-Standard zurücksetzen',
    turn_off: 'Servicegebühr deaktivieren',
  },
  toasts: {
    load_error: 'Servicegebühr-Einstellungen konnten nicht geladen werden.',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
    reset_to_default: 'Überschreibung entfernt — es gilt der Partner-Standard.',
    reset_to_default_skipped: 'Überschreibung entfernt — es wird keine Servicegebühr erhoben, bis Sie eine speichern.',
    turned_off: 'Servicegebühr deaktiviert. Ihre Werte bleiben gespeichert, falls Sie sie wieder aktivieren.',
  },
};
